// extracted by mini-css-extract-plugin
export default {"addClassContainer":"AddClasses_addClassContainer__xaoZX","closeButton":"AddClasses_closeButton__08i-n","fadeIn":"AddClasses_fadeIn__6wbnv","fadeOut":"AddClasses_fadeOut__qXWsM"};